import { Routes } from '@angular/router';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { AuthGuard } from './common/guards/auth.guard';
import { LoginComponent } from './components/handle-user/login/login.component';
import { RegisterComponent } from './components/handle-user/register/register.component';
import { ProfileComponent } from './components/profile/profile/profile.component';
import { EmploymentFormComponent } from './components/profile/employment/employment-form/employment-form.component';
import { OrganisationFormComponent } from './components/profile/organisation/organisation-form/organisation-form.component';
import { ChangePasswordComponent } from './components/handle-user/change-password/change-password.component';
import { ResetPasswordComponent } from './components/handle-user/reset-password/reset-password.component';
import { TermsComponent } from './components/terms/terms/terms.component';
import { PersonalDataFormComponent } from './components/profile/personalData/personal-data-form/personal-data-form.component';
import { ChangeEmailComponent } from './components/handle-user/change-email/change-email.component';
import { ConsentGuard } from './common/guards/consent.guard';
import { BenefitFormComponent } from './components/profile/benefits/benefit-form/benefit-form.component';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: '', // authenticated Area
    canActivate: [AuthGuard, ConsentGuard],
    children: [
      {
        path: 'profile',
        component: ProfileComponent,
        data: {title: 'portal.Profile.Profile'},
        children: [
          {
            path: 'personalData:id',
            component: PersonalDataFormComponent,
            data: {title: 'portal.Profile.PersonalData.Form.Edit'}
          },
          {
            path: 'organisation',
            component: OrganisationFormComponent,
            data: {title: 'portal.Profile.Organisation.Form.Add'},
            children: [
              {
                path: ':id',
                component: OrganisationFormComponent,
                data: {title: 'portal.Profile.Organisation.Form.Edit'}
              }
            ]
          },
          {
            path: 'employment',
            component: EmploymentFormComponent,
            data: {title: 'portal.Profile.Employment.Form.Add'},
            children: [
              {
                path: ':id',
                component: EmploymentFormComponent,
                data: {title: 'portal.Profile.Employment.Form.Edit'}
              }
            ]
          },
          {
            path: 'benefit:id',
            component: BenefitFormComponent,
            data: {title: 'portal.Profile.Benefit.Form.Edit'}
          },
        ]
      },
      {
        path: 'changepassword',
        component: ChangePasswordComponent,
        data: {title: 'portal.ChangePassword'},
      },
      {
        path: 'changeemail',
        component: ChangeEmailComponent,
        data: {title: 'portal.ChangeEmail'},
      }
    ]
  },
  {
    path: 'terms',
    component: TermsComponent,
    data: {title: 'portal.Terms'}
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {title: 'portal.Login'}
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {title: 'portal.Register'}
  },
  {
    path: 'resetpassword',
    component: ResetPasswordComponent,
    data: {title: 'portal.ResetPassword'},
    children: [
      {
        path: ':token',
        component: ResetPasswordComponent,
        data: {title: 'portal.ResetPassword'}
      }
    ]
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];
